// English translations for Hipro Technologies
const en = {
  meta: { code: 'en', name: 'English', flag: '🇬🇧' },

  nav: {
    home: 'Home', about: 'About', services: 'Services', portfolio: 'Portfolio',
    pricing: 'Pricing', industries: 'Industries', insights: 'Insights', contact: 'Contact',
    bookFreeCall: 'Book Free Call',
  },

  common: {
    getFreeConsultation: 'Get Free Consultation',
    exploreServices: 'Explore Services',
    viewDetails: 'View Details',
    bookAppointment: 'Book Free Appointment',
    choosePackage: 'Choose Package',
    scheduleCall: 'Schedule a Call',
    talkToSales: 'Talk to Sales',
    readArticle: 'Read Article',
    viewAllPortfolio: 'View All Portfolio',
    viewAllInsights: 'View All Insights',
    requestCustomQuote: 'Request Custom Quote',
    backHome: 'Back home',
    backToPortfolio: 'Back to portfolio',
    trustedWorldwide: 'Trusted by Businesses Worldwide',
    isoCertified: 'ISO 27001 & ISO 9001 Certified',
    all: 'All',
    allIndustries: 'All industries',
    industryLabel: 'Industry',
    chatOnWhatsapp: 'Chat on WhatsApp',
    submitting: 'Submitting…',
    loading: 'Loading…',
  },

  hero: {
    badge: 'ISO/IEC 27001:2022 & ISO 9001:2015 Certified Technology Company',
    titleA: 'AI-Powered', titleB: 'Software', titleC: ',',
    titleD: 'Cloud & Digital Growth', titleE: 'Partner', titleF: '.',
    subtitleLead: 'Trusted by businesses across',
    countries: 'USA, UK, UAE, Netherlands, Malaysia, Hong Kong and India',
    subtitleRest: 'to build, grow and scale faster. From custom software and websites to AI automation, SEO and mobile apps — we ship digital solutions that generate leads, increase revenue and accelerate growth.',
    stats: {
      years: 'Years Experience', offices: 'Global Offices',
      projects: 'Projects Delivered', retention: 'Client Retention',
    },
  },

  form: {
    title: 'Talk to an Expert',
    subtitle: 'Get a FREE consultation & project estimate within 24 hours.',
    ribbon: 'Book Free Strategy Call',
    name: 'Name*', namePh: 'Your full name',
    email: 'Email*', emailPh: 'you@company.com',
    mobile: 'Mobile Number*', mobilePh: 'Mobile number',
    selectService: 'Select Services*', servicePh: '---- Select Services ----',
    hear: 'How did you hear of us?*', hearPh: '---- Select Option ----',
    submit: 'Book Free Strategy Call',
    success: 'Request received',
    successDesc: 'A Hipro specialist will contact you within 24 hours.',
    validation: 'Please fill required fields',
    validationDesc: 'Name, email and mobile number are required.',
    error: 'Could not submit',
  },

  about: {
    kicker: 'Established in 2015. Powered by leadership experience since 2010.',
    titleA: 'Trusted by Businesses',
    titleB: 'Worldwide',
    body: 'Over the last decade, Hipro Technologies has helped businesses design and build websites, software platforms and digital products across multiple industries. With teams in the USA, UK, UAE, Netherlands, Malaysia, Hong Kong and India, we deliver enterprise-grade engineering with local partnership.',
    features: [
      { t: '7 Countries', d: 'Delivery centres across USA, UK, UAE, Netherlands, Malaysia, Hong Kong & India.' },
      { t: 'ISO Certified', d: 'ISO/IEC 27001:2022 & ISO 9001:2015 certified processes.' },
      { t: 'Agile Delivery', d: 'Two-week sprints with daily standups & transparent reporting.' },
      { t: '24/7 Support', d: 'Follow-the-sun engineering & SLA-backed support.' },
    ],
    stats: [
      { label: 'Digital Projects' }, { label: 'Technology Professionals Worldwide' },
      { label: 'Clients Served' }, { label: 'Global Markets' },
    ],
    gapKicker: '96% of companies face this gap…',
    gapTitle: 'Strong ideas, weak execution.',
    gapBody: 'We are not a firm offering deliverables. We are your growth partner — owning outcomes from strategy to launch.',
  },

  services: {
    kicker: 'End-to-End IT Services',
    title: 'Web, Software & Digital Marketing Services',
    body: 'From idea to execution, Hipro Technologies helps businesses build powerful digital experiences that attract customers, streamline operations and create long-term growth.',
    childServices: 'Child Services Included',
    items: {
      design: {
        tag: 'Creative',
        title: 'Design & Creative',
        subtitle: 'Crafting beautiful, intuitive digital experiences.',
        list: ['Website Design', 'Graphic Design', 'UI/UX Design', 'Branding & Identity', 'Video Production', 'Social Media Creatives', 'Motion Graphics'],
      },
      development: {
        tag: 'Popular',
        title: 'Development & Technology',
        subtitle: 'Building robust, scalable applications and systems.',
        list: ['Mobile App Development', 'eCommerce Development', 'Custom Software Development', 'Web Application Development', 'ERP/CRM Solutions', 'API Integrations', 'SaaS Development'],
      },
      marketing: {
        tag: 'High-Demand',
        title: 'Marketing & Growth',
        subtitle: 'Data-driven strategies to scale your business.',
        list: ['Digital Marketing', 'Performance Marketing', 'SEO & GEO Services', 'Meta Ads', 'Google Ads', 'Lead Generation', 'Social Media Management', 'Content Marketing'],
      },
      ai_automation: {
        tag: 'AI-Powered',
        title: 'AI & Automation',
        subtitle: 'Intelligent systems that cut costs and unlock scale.',
        list: ['AI Chatbots & Assistants', 'Workflow & Process Automation', 'Document Intelligence (OCR + LLM)', 'AI Candidate & Lead Screening', 'Predictive Analytics & ML Models', 'LLM Integration & Fine-tuning'],
      },
      custom_software: {
        tag: 'Tailor-Made',
        title: 'Custom Software Development',
        subtitle: 'Purpose-built software around your exact workflows.',
        list: ['Product Discovery & Architecture', 'SaaS Platforms', 'Internal Tools & Portals', 'API Design & Integrations', 'Multi-tenant Systems', 'Quality Assurance & Test Automation'],
      },
      cloud_devops: {
        tag: 'Scalable',
        title: 'Cloud & DevOps',
        subtitle: 'Reliable, secure and cost-optimised infrastructure.',
        list: ['AWS / Azure / GCP Architecture', 'Kubernetes & Containerisation', 'CI/CD Pipelines', 'Infrastructure as Code (Terraform)', 'Monitoring & Observability', 'Cloud Cost Optimisation'],
      },
      data_analytics: {
        tag: 'Insight-Driven',
        title: 'Data & Analytics',
        subtitle: 'Turn raw data into decisions your teams trust.',
        list: ['Data Warehousing & Pipelines', 'Business Intelligence Dashboards', 'ETL / ELT Engineering', 'Real-time Analytics', 'Data Governance & Quality', 'Customer 360 & Reporting'],
      },
      cybersecurity: {
        tag: 'Secure',
        title: 'Cybersecurity',
        subtitle: 'Protect your applications, data and reputation.',
        list: ['Security Audits & Pen Testing', 'Secure SDLC & Code Review', 'Identity & Access Management', 'SOC 2 / ISO 27001 / GDPR Readiness', 'Vulnerability Management', 'Incident Response Planning'],
      },
      app_modernization: {
        tag: 'Future-Proof',
        title: 'Application Modernization',
        subtitle: 'Move legacy systems to modern, maintainable stacks.',
        list: ['Legacy Audit & Modernisation Roadmap', 'Monolith to Microservices', 'Cloud Migration & Re-platforming', 'UI/UX Revamp of Legacy Apps', 'Database Modernisation', 'Zero-downtime Migration Strategy'],
      },
      enterprise_solutions: {
        tag: 'Enterprise',
        title: 'Enterprise Solutions',
        subtitle: 'Mission-critical platforms for large organisations.',
        list: ['ERP & CRM Implementation', 'HRMS & Payroll Systems', 'Supply Chain & Logistics Platforms', 'Enterprise Integrations (SAP, Salesforce)', 'Custom Workflow Engines', 'Role-based Access & Compliance'],
      },
      managed_it: {
        tag: '24/7',
        title: 'Managed IT Services',
        subtitle: 'Your always-on technology team, without the overhead.',
        list: ['24/7 Monitoring & Support', 'SLA-backed Maintenance', 'Helpdesk & Ticketing', 'Patch & Release Management', 'Backup & Disaster Recovery', 'Dedicated Support Engineers'],
      },
    },
  },

  portfolio: {
    kicker: 'Portfolio',
    title: 'Recent Projects & Success Stories',
    empty: 'No case studies match those filters yet. Try clearing them.',
  },

  tech: {
    kicker: 'Tech Stack & Engineering Tools',
    title: 'Technologies We Work With',
    body: 'We deploy modern programming languages, packages and cloud techniques to build scalable digital experiences.',
  },

  industries: {
    kicker: 'Our Domain Expertise',
    title: 'Industries We Serve',
    body: 'Delivering specialised software solutions across diverse sectors with deep industry expertise.',
    customKicker: 'Custom Domain Requirement?',
    customTitle: 'Don’t See Your Industry Listed?',
    customBody: 'We engineer tailor-made software solutions across many more specialised sectors.',
    items: {
      healthcare: { name: 'Healthcare', desc: 'HIPAA-compliant healthcare software, telemedicine and EHR platforms.' },
      education: { name: 'Education', desc: 'Modern LMS, e-learning and school management platforms.' },
      finance: { name: 'Finance', desc: 'Secure fintech products, banking, and wealth management apps.' },
      retail: { name: 'Retail', desc: 'Modern eCommerce, POS and omnichannel retail solutions.' },
      manufacturing: { name: 'Manufacturing', desc: 'Smart automation and industry 4.0 software solutions.' },
      realestate: { name: 'Real Estate', desc: 'Property management, listing portals and CRM platforms.' },
      travel: { name: 'Travel', desc: 'OTA platforms, booking engines and travel management.' },
      automotive: { name: 'Automotive', desc: 'Dealer platforms, fleet, and connected vehicle solutions.' },
      technology: { name: 'Technology', desc: 'SaaS platforms, developer tools and enterprise software.' },
    },
  },

  process: {
    kicker: 'Proven Agile Workflow',
    title: 'How We Work',
    body: 'A reliable agile development process to deliver scalable, secure and high-performance websites & digital applications.',
    steps: {
      '01': { tag: 'Discovery & Scope', title: 'Requirement Analysis', items: ['Business analysis', 'Target users', 'Requirements', 'Project scope'] },
      '02': { tag: 'Wireframe & UI', title: 'UI/UX Design Process', items: ['Wireframing', 'UI Design', 'Prototyping', 'User testing'] },
      '03': { tag: 'Full-Stack Dev', title: 'Application Development', items: ['Code quality', 'Version control', 'Best practices', 'Testing integration'] },
      '04': { tag: 'QA & Security', title: 'Quality Testing Process', items: ['Functional tests', 'Performance', 'Security', 'Device testing'] },
      '05': { tag: 'Store & Cloud', title: 'Application Deployment', items: ['Store submission', 'App review', 'ASO optimization', 'Launch process'] },
      '06': { tag: '24/7 SLA Support', title: 'Support and Scaling', items: ['Bug fixes', 'Updates', 'Scaling', 'Support'] },
    },
    stepPrefix: 'Step',
  },

  insights: {
    kicker: 'Latest Updates', title: 'Insights & News',
    body: 'Expert insights on digital marketing, SEO, AI innovation and business growth from the Hipro team.',
  },

  faq: {
    kicker: 'Got Questions?', title: 'Frequently Asked Questions',
    body: 'Everything you need to know about our services, processes and how we accelerate your digital growth.',
    clientKicker: 'Client Voices', clientTitle: 'What Clients Say About Hipro',
    shareYours: 'Share Yours',
  },

  cta: {
    kicker: 'Ready to start your project?',
    titleA: 'Let’s Build Your', titleB: 'Growth Story', titleC: 'Together',
    body: 'The best time to take your business online is now. Choose the right engagement and talk directly with our technology experts on WhatsApp.',
  },

  contactMap: {
    kicker: 'Find Us',
    title: 'Visit our nearest office',
    body: '13 offices across India, USA, UK, UAE, Malaysia, Netherlands and Hong Kong. Pick a location to see it on the map and get directions in one tap.',
    directions: 'Get directions',
    nearest: 'Nearest to you',
    useMyLocation: 'Use my location',
  },

  footer: {
    globalKicker: 'Global Presence',
    globalTitle: 'Our Global Offices',
    globalSub: '13 offices across 7 countries — find the Hipro team nearest to you.',
    globalAll: 'All countries',
    officesLabel: 'Offices',
    countriesLabel: 'Countries',
    tagline: 'Hipro Technologies is an ISO-certified global IT services company delivering software engineering, AI automation, cloud, and digital marketing outcomes for ambitious businesses.',
    servicesTitle: 'Services', companyTitle: 'Company', contactTitle: 'Contact',
    servicesList: ['Web Development', 'Mobile App Development', 'Custom Software Development', 'AI & Automation', 'Cloud & DevOps', 'Data & Analytics', 'Cybersecurity', 'Application Modernization', 'Enterprise Solutions', 'Managed IT Services', 'Digital Marketing & SEO'],
    companyList: ['About Us', 'Portfolio', 'Industries', 'Insights', 'Careers', 'Contact'],
    rightsReserved: 'All rights reserved.',
    privacy: 'Privacy Policy', terms: 'Terms of Service', cookies: 'Cookie Policy',
  },

  book: {
    kicker: 'Book a Meeting',
    title: 'Pick a time. We’ll bring the ideas.',
    body: '30-minute strategy call with a senior consultant. No pressure — just clear next steps.',
    pickDate: 'Pick a date', pickSlot: 'Available slots on',
    loadingSlots: 'Loading slots…',
    slotNote: 'Slots are in IST (India time). Your local equivalent appears under each slot — ✓ marks a comfortable hour for you.',
    fullName: 'Full name *', workEmail: 'Work email *', phone: 'Phone', timezone: 'Timezone',
    help: 'What can we help you with?', helpPh: 'Select a service',
    notes: 'Anything else we should know?', notesPh: 'Project stage, goals, timeline…',
    yourBooking: 'Your booking', pickSlotPlaceholder: 'Pick a slot',
    autoTz: 'Timezone detected', nearest: 'Nearest office', yourTime: 'your time',
    confirm: 'Confirm meeting', confirming: 'Confirming…',
    disclaimer: 'By booking, you agree to receive a calendar invite and follow-up email from Hipro Technologies. No spam — unsubscribe anytime.',
    booked: 'You’re booked in!',
    bookedBody: 'A calendar invite has been reserved for you. Add it to your calendar so you don’t miss it.',
    downloadIcs: 'Download .ics invite',
    backToHome: 'Back to Home',
    reminder: 'Reminder: our team will reach out over email with the meeting link and a short brief before the call.',
    confirmedToast: 'Meeting confirmed!',
    confirmedToastDesc: 'Check your email for details. You can also add it to your calendar.',
    slotTaken: 'Slot just booked',
    slotTakenDesc: 'That slot was taken. Please pick another one.',
  },

  pricing: {
    kicker: 'Transparent Pricing',
    title: 'Packages priced in your local currency',
    body: 'Auto-detected from your location. Switch anytime — we work with clients across USA, UK, EU, UAE, Malaysia, Hong Kong & India.',
    pricesShownIn: 'Prices shown in',
    fxNote: 'approximate, based on today’s FX.',
    mostPopular: 'Most Popular',
    bestFor: 'Best for:', delivery: 'Delivery:',
    taxes: 'Taxes not included. Enterprise and long-term retainers are custom-priced — book a call for a detailed proposal.',
  },

  testimonial: {
    hero: 'Share your Hipro story',
    subtitle: 'Loved working with us? Send us a quick testimonial. New submissions are moderated before appearing on the site.',
    yourName: 'Your name *', role: 'Role', company: 'Company', country: 'Country',
    feedback: 'Your feedback *', feedbackPh: 'Tell us what worked and what we could do better…',
    rating: 'Rating',
    photo: 'Your photo (optional)', logo: 'Company logo (optional)',
    submit: 'Submit testimonial',
    thankTitle: 'Thank you!',
    thankBody: 'Your testimonial is pending review and will appear once approved.',
    almost: 'Almost there', almostBody: 'Please share your name and at least a short quote.',
    tooLarge: 'Image too large', tooLargeBody: 'Keep under 1.2MB.',
  },

  caseStudy: {
    problem: 'The Problem',
    solution: 'Our Solution',
    outcomes: 'Measurable Outcomes',
    techStack: 'Tech Stack',
    similar: 'Have a similar project?',
    similarBody: 'Get a free consultation and estimate within 24 hours.',
    bookCall: 'Book a Call', seePricing: 'See Pricing',
    team: 'Team', duration: 'Duration', client: 'Client', industry: 'Industry',
    notFound: 'Case study not found', notFoundBody: 'The project you’re looking for doesn’t exist or has been moved.',
  },
};

export default en;
